const config = {
  api: {
    url: process.env.REACT_APP_API_URL,
    timeout: Number(process.env.REACT_APP_API_TIMEOUT ?? '0')
  },
  auth: {
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
    authorityUrl: process.env.REACT_APP_AUTH_AUTHORITY_URL,
    authorizationEndpoint: process.env.REACT_APP_AUTH_AUTHORIZATION_ENDPOINT,
    jwksUri: process.env.REACT_APP_AUTH_JWKS_URI
  },
  contactUs: {
    url: process.env.REACT_APP_CONTACT_US_URL
  }
};

export default config;
